shvenergy.cookies = (function () {
	"use strict";

	function setCookie(name, value, days) {
		var expires;

		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = `; expires=${date.toGMTString()}`;
		} else {
			expires = "";
		}
		document.cookie = encodeURIComponent(name) + "=" + value + expires + "; path=/";
	}

	function getCookie(name) {
		const nameEq = encodeURIComponent(name) + "=";
		const ca = document.cookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEq) === 0) return decodeURIComponent(c.substring(nameEq.length, c.length));
		}
		return null;
	}

	function deleteCookie(name) {
		setCookie(name, "", -1);
	}

	function cookieConsentListener() {
		window.addEventListener('cookieConsent', function(e) {
			var str = JSON.stringify(e.detail.consentedCategories);
			shvenergy.cookies.setCookie('_shvenergy_cookie_consent', str, e.detail.durationDays);
			handleUTMParameters();
		});
	}

	function getCookieCategories(cookieName) {
		if (!window.cookieConsentSettings) {
			return false;
		}

		var categories = cookieConsentSettings.Categories.filter(function(category) {
			return category.Cookies.some(function(cookie) {
                return cookie == cookieName;
            })
        })

        return categories;
    }

	function hasCookieCategoryConsent(cookieName) {
		var cookieCategories = getCookieCategories(cookieName);

		if (cookieCategories && cookieCategories.length > 0) {
			var requireConsent = cookieCategories.every(function(category) {
                return category.RequireConsent;
            })

			if (!requireConsent) {
                return true;
			}

			var consentCookie = shvenergy.cookies.getCookie('_shvenergy_cookie_consent');
            if (!consentCookie) {
                return false;
			}

            var cookieValueLowerCase = consentCookie.toLowerCase();
			var result = cookieCategories.some(function(category) {
				return cookieValueLowerCase.includes(category.CategoryName.toLowerCase());
            })

            return result;
        }

        return false;
	}

	function handleUTMParameters() {
		var searchParams = new URLSearchParams(window.location.search);
		var utmParams = {};
		var utmParamsList = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign', 'gclid'];
		for (var i = 0; i < utmParamsList.length; i++) {
			if (searchParams.has(utmParamsList[i])) {
				utmParams[utmParamsList[i]] = searchParams.get(utmParamsList[i]);
			}
		}		
		utmParams = JSON.stringify(utmParams);
		// Only set cookie if utmParams has any key/value pairs
		if (utmParams !== '{}') {
			
			if (shvenergy.cookies.hasCookieCategoryConsent('_shvenergy_utm')) {
				shvenergy.cookies.setCookie('_shvenergy_utm', utmParams, 1/48);
			}
		}
	}

	function init() {
		cookieConsentListener();
	}

	init();

	return {
		setCookie: setCookie,
		getCookie: getCookie,
		deleteCookie: deleteCookie,
		hasCookieCategoryConsent: hasCookieCategoryConsent,
		handleUTMParameters: handleUTMParameters
	};
})();